var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDialog',{attrs:{"propDialog":_vm.dialog,"max-width":800,"title":_vm.$t('invoice.payment-proof'),"actionable":false},on:{"closeDialog":_vm.setDialog}},[_c('div',{staticClass:"d-flex justify-center"},[_c('InnerImageZoom',{attrs:{"src":_vm.imgUrl}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }